import React from 'react';

interface Props {
  title: string;
  points: string[];
}

export const LegalSection: React.FC<Props> = ({ title, points }) => (
  <div className="flex flex-col gap-4 w-full">
    <h3 className="text-headline-20 text-foreground">{title}</h3>
    <div className="flex flex-col gap-3">
      {points.map((point) => (
        <p key={point} className="text-body-16 text-muted-foreground">
          {point}
        </p>
      ))}
    </div>
  </div>
);
